import {Card, Nav} from 'react-bootstrap'
import {useState} from 'react'
import {EmailSettingsTab} from './components/EmailSettingsTab'
import {EmailSetupTab} from './components/EmailSetupTab'

type PolicytoolsTab = 'email'
type EmailSubTab = 'emailSetup' | 'emailSettings'

export const PolicytoolsSettingsPage = () => {
  const [activeTab, setActiveTab] = useState<PolicytoolsTab>('email')
  const [activeEmailSubTab, setActiveEmailSubTab] = useState<EmailSubTab>('emailSetup')

  return (
    <div className='container-fluid p-8'>
      <div className='mb-8'>
        <h1 className='page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0'>
          Policytools Settings
        </h1>
        <span className='text-muted fs-7 fw-semibold mt-1 d-block'>
          Configuración default del sistema (SuperAdmin)
        </span>
      </div>

      <Card className='mb-0'>
        <Card.Header className='border-0 pt-5 px-5 pb-0'>
          <Nav variant='tabs' activeKey={activeTab} onSelect={(k) => setActiveTab((k as PolicytoolsTab) || 'email')}>
            <Nav.Item>
              <Nav.Link eventKey='email' className='fw-bold'>
                <i className='bi bi-envelope me-2' />
                Email Configurations
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>
        <Card.Body className='p-5'>
          {activeTab === 'email' && (
            <>
              <Nav
                variant='pills'
                activeKey={activeEmailSubTab}
                onSelect={(k) => setActiveEmailSubTab((k as EmailSubTab) || 'emailSetup')}
                className='mb-5'
              >
                <Nav.Item>
                  <Nav.Link eventKey='emailSetup' className='fw-bold'>
                    <i className='bi bi-server me-2' />
                    Email Setup
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey='emailSettings' className='fw-bold'>
                    <i className='bi bi-envelope me-2' />
                    Email Settings
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              {activeEmailSubTab === 'emailSetup' && <EmailSetupTab />}
              {activeEmailSubTab === 'emailSettings' && <EmailSettingsTab />}
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}
